import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { LatLng } from '../../entities/latlng';

declare var google;

@Component({
    selector: 'googlemap',
    templateUrl: 'googlemap.html'
})
export class GoogleMapComponent {

    @Input('markers') markers: LatLng[];
    @ViewChild('map') mapElement: ElementRef;

    map: any;
    directionsDisplay = new google.maps.DirectionsRenderer;

    async initMap(mapWidth: number, mapHeight: number) {

        this.map = new google.maps.Map(this.mapElement.nativeElement, {
            zoom: 8,
            center: { lat: 54.2361, lng: -4.5481 },
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false
        });

        let bounds = new google.maps.LatLngBounds();
        let previousMarker: any;
        for (let marker of this.markers) {
            let mapMarker = new google.maps.Marker({
                map: this.map,
                position: marker,
                icon: 'assets/imgs/icons/map-marker.svg',
            });
            bounds.extend(mapMarker.getPosition());

            if (previousMarker !== undefined) {
                new google.maps.Polyline({
                    path: [previousMarker, marker],
                    strokeOpacity: 0,
                    icons: [{
                        icon: {
                            path: 'M 0,-1 0,1',
                            strokeColor: '#003DA6',
                            strokeOpacity: 1,
                            scale: 1.5
                        },
                        repeat: '8px'
                    }],
                    map: this.map
                });
            }
            previousMarker = marker;
        }


        this.map.fitBounds(bounds);
        this.map.setCenter(bounds.getCenter());

        let map: any = this.map;
        let listener = google.maps.event.addListener(this.map, 'idle', () => {
            let zoom: number = this.map.getZoom();
            if (mapHeight < 200)
                zoom++;
            else if (mapHeight > 600)
                zoom--;
            map.setZoom(zoom);
            google.maps.event.removeListener(listener);
        });

        this.directionsDisplay.setMap(this.map);
    }

}



// WEBPACK FOOTER //
// ./src/components/googlemap/googlemap.ts